import React, { useState } from "react";
import { Button } from "@mui/material";
import WorkspaceStandingsTable from "./LegacyWorkspaceStandingsTable";
import { prepareLeagueRowsForScope } from "../helpers/compactLeagueRows";
import { futureSummary } from "../helpers/LegacyteamAnalysis";
export default function TeamLeagueInline({ data, teamId, en, mode }) {
  const [showStatistics, setShowStatistics] = useState(false),
    [source, setSource] = useState("actual");
  const t = (d, e) => (en ? e : d);
  const fmt = (n, d = 2) =>
    Number.isFinite(n)
      ? n.toLocaleString(en ? "en-GB" : "de-DE", {
          minimumFractionDigits: d,
          maximumFractionDigits: d,
        })
      : "—";
  const labels = {
    played: t("Spiele", "Played"),
    won: t("Siege", "Wins"),
    draw: t("Remis", "Draws"),
    lost: t("Niederlagen", "Losses"),
    goals: t("Tore", "Goals"),
    difference: t("Differenz", "Difference"),
    points: t("Punkte", "Points"),
  };
  const names = {
    actual: t("Real erspielt", "Actual performance"),
    expected: t("Ergebnismodell · erwartet", "Results model · expected"),
    should: "Should Goals",
    market: t("Historische Marktrückrechnung", "Historical market inversion"),
  };
  const rows = prepareLeagueRowsForScope(
    source === "actual" ? data.actual_table : data.comparison_tables?.[source],
    source,
    "overall"
  ).map((r) => ({
    ...r,
    result: futureSummary(data.result_teams?.[r.teamId]),
    statistics: data.ranking?.find((x) => x.team_id === r.teamId),
  }));
  const rulesFor = (id) =>
    (data.standing_rules || []).filter(
      (r) =>
        r.is_regular_stage !== false &&
        (r.position != null
          ? Number(r.position) === rows.find((x) => x.teamId === id)?.position
          : Number(r.team_id) === id)
    );
  return (
    <div className={`team-league-workspace tl-${mode}`}>
      <label>
        {t("Tabellengrundlage", "Table basis")}{" "}
        <select value={source} onChange={(e) => setSource(e.target.value)}>
          {Object.entries(names).map(([k, l]) => (
            <option key={k} value={k}>
              {l}
            </option>
          ))}
        </select>
      </label>
      <Button onClick={() => setShowStatistics((v) => !v)}>
        {showStatistics
          ? t("Statistik ausblenden", "Hide statistics")
          : t("Statistik anzeigen", "Show statistics")}
      </Button>
      <WorkspaceStandingsTable
        {...{ rows, data, showStatistics, rulesFor, fmt, t, en }}
        selectedTeam={teamId}
        visibleColumns={Object.keys(labels)}
        visibleMetrics={["quotient", "goalAverage"]}
        groups={[
          names[source],
          t(
            "Gespeicherte Settings · Ergebnismodell",
            "Saved settings · Results model"
          ),
          t(
            "Gespeicherte Settings · Statistikmodell",
            "Saved settings · Statistics model"
          ),
        ]}
        columnClass={(k) =>
          ["played", "won", "draw", "lost"].includes(k)
            ? "tl-record-column"
            : k === "points"
            ? "tl-points"
            : k === "goals"
            ? "tl-goals"
            : "tl-number"
        }
        digits={(k) => (k === "played" || source === "actual" ? 0 : 2)}
        labels={labels}
      />
    </div>
  );
}
